import {Component, EventEmitter, Input, Output} from '@angular/core';
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {HttpStatusCode} from "@angular/common/http";
import {ActivatedRoute} from "@angular/router";
import {CustomMessageService} from "library";
import {ResponseHttpError, ResponseHttpSuccess} from "library";
import {RequestService} from "projects/store/src/app/services/api/v1/request.service";
import {SalesWorkflowSteps} from "projects/store/src/app/enums";

@Component({
  selector: 'app-sales-phone-register-manual-introduce-imei',
  templateUrl: './sales-phone-register-manual-introduce-imei.component.html',
  styles: [
  ]
})
export class SalesPhoneRegisterManualIntroduceImeiComponent {
  form: FormGroup;
  requestId: string;
  submitted = false;
  loading = false;
  hasEnrollmentError = false;
  errorMessage!: string
  @Output() step = new EventEmitter();
  @Output() phoneEnrollmentData = new EventEmitter();
  @Output() nextStepEvent = new EventEmitter();
  @Output() gotoStepEvent = new EventEmitter();
  @Input() visibleModalEnterIMEI: any;
  constructor( private route: ActivatedRoute,
               private customMessageService: CustomMessageService,
               private requestService: RequestService) {
    this.form = new FormGroup({
      imei: new FormControl('', [Validators.required]),
    });
    this.requestId = this.route.snapshot.params['request_id'];
  }

  onProgressEnrollment() {
    this.submitted = true;
    if(this.form.invalid){
      return;
    }

    this.save();
  }

  save(){
    this.loading = true;
    this.requestService.retryImeiLogin(this.form.value, this.requestId).subscribe({
      next: (resp: ResponseHttpSuccess)=> {
        if (resp.status === HttpStatusCode.Created) {
          this.onNextStep();
        }else{
          this.customMessageService.responseNoticeHandler(resp);
        }
        this.loading = false;
      },
      error: (error: ResponseHttpError) => {
        console.log(error.error.message);
        this.errorMessage = error.error.message;
        this.form.get('imei')?.setErrors({ serverError: true });
        this.hasEnrollmentError = true;
        this.loading = false;
      }
    });
  }

  onNextStep() {
    this.nextStepEvent.emit();
  }

  onHide(){
    this.step.emit('general-instructions');
  }


  onGotoStep(stepCode: string) {
    this.gotoStepEvent.emit(stepCode);
  }

  get f(){
    return this.form.controls;
  }

  protected readonly SalesWorkflowSteps = SalesWorkflowSteps;
}
